(() => {
  const header = document.querySelector('[data-ugly-header]');
  if (header) {
    const drawer = header.querySelector('[data-ugly-mobile-drawer]');
    const scrim = header.querySelector('[data-ugly-scrim]');
    const toggle = header.querySelector('[data-ugly-menu-toggle]');
    const close = header.querySelector('[data-ugly-menu-close]');
    const setDrawer = (open) => {
      drawer?.classList.toggle('is-open', open);
      scrim?.classList.toggle('is-open', open);
      drawer?.setAttribute('aria-hidden', String(!open));
      toggle?.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('ugly-menu-open', open);
    };
    toggle?.addEventListener('click', () => setDrawer(true));
    close?.addEventListener('click', () => setDrawer(false));
    scrim?.addEventListener('click', () => setDrawer(false));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setDrawer(false); });

    const items = [...header.querySelectorAll('.ugly-nav-item--mega')];
    const closeMega = (except) => items.forEach((item) => {
      if (item === except) return;
      item.classList.remove('is-open');
      item.querySelector('.ugly-nav-trigger')?.setAttribute('aria-expanded', 'false');
    });
    items.forEach((item) => {
      const trigger = item.querySelector('.ugly-nav-trigger');
      const open = () => { closeMega(item); item.classList.add('is-open'); trigger?.setAttribute('aria-expanded', 'true'); };
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', () => { item.classList.remove('is-open'); trigger?.setAttribute('aria-expanded', 'false'); });
      trigger?.addEventListener('focus', open);
      trigger?.addEventListener('click', (event) => {
        if (matchMedia('(hover: hover)').matches && !item.classList.contains('is-open')) { event.preventDefault(); open(); }
      });
    });
    document.addEventListener('click', (event) => { if (!header.contains(event.target)) closeMega(); });
  }

  let toastTimer;
  const syncCartCount = async () => {
    const root = window.Shopify?.routes?.root || '/';
    const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((value) => value.json());
    document.querySelectorAll('.ugly-cart-count').forEach((count) => {
      count.classList.toggle('hidden', !cart.item_count);
      count.textContent = String(cart.item_count);
    });
    return cart;
  };
  const showCartToast = (title) => {
    let toast = document.querySelector('.ugly-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ugly-cart-toast';
      toast.setAttribute('role', 'status');
      document.body.append(toast);
    }
    toast.innerHTML = `<strong>ITEM ADDED TO YOUR CART</strong><span>${title || 'Your item is ready.'}</span><a href="/cart">VIEW CART</a>`;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 4200);
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form || form.classList.contains('ugly-quick-add')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.uglySubmitting === 'true') return;
    form.dataset.uglySubmitting = 'true';
    const button = event.submitter || form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    const title = document.querySelector('main h1')?.textContent?.trim() || 'Your item';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!response.ok) throw new Error('Cart request failed');
      const item = await response.json();
      await syncCartCount();
      showCartToast(item.product_title || title);
    } catch (_error) {
      window.location.href = '/cart';
    } finally {
      form.dataset.uglySubmitting = 'false';
      if (button) button.disabled = false;
    }
  }, true);

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.ugly-quick-add');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button');
    button.disabled = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Cart request failed');
      const item = await response.json();
      await syncCartCount();
      showCartToast(item.product_title || item.title);
    } catch (_error) {
      window.location.href = '/cart';
    } finally {
      button.disabled = false;
    }
  });
})();
